export default {"src":"/_next/static/media/our-partners-img-eight.3dc2746e.svg","height":49,"width":150};